import React, { useState, useEffect } from 'react';

const TransactionPage = () => {
  const [formData, setFormData] = useState({
    category: '',
    phoneNumber: '',
    amount: '',
    paymentId: ''
  });

  const [paymentHistory, setPaymentHistory] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [filter, setFilter] = useState('All');

  const styles = {
    container: {
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    header: {
      fontSize: '20px',
      marginBottom: '20px',
      color: '#333',
    },
    formContainer: {
      display: 'flex',
      gap: '15px',
      marginBottom: '30px',
      alignItems: 'center',
    },
    input: {
      padding: '8px 12px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '14px',
      minWidth: '200px',
    },
    select: {
      padding: '8px 12px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '14px',
      minWidth: '200px',
    },
    
    saveButton: {
      padding: '8px 24px',
      backgroundColor: '#3366ff',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '20px',
      border: '1px solid #ddd',
    },
    th: {
      textAlign: 'left',
      padding: '12px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #ddd',
      borderBottom: '2px solid #ddd',
    },
    td: {
      padding: '12px',
      border: '1px solid #ddd',
    },
    historyHeader: {
      fontSize: '16px',
      color: '#666',
      marginTop: '30px',
      marginBottom: '10px',
    }
  };

  useEffect(() => {
    // Fetch data from the API
    const fetchTransactionData = async () => {
      const token = localStorage.getItem('token'); // Get the token from localStorage

      if (!token) {
        console.error('No token found in localStorage.');
        return;
      }

      try {
        const response = await fetch('https://admindashboard.clns.in/api/student/student_transactions/', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`, // Include token in Authorization header
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();

        // Map API data into the format needed for the table
        const formattedData = data.transactions.map(transaction => ({
          userType: transaction.name?.name || 'Unknown', // Handle missing names
          date: new Date(transaction.transaction_time).toLocaleDateString(),
          amount: parseFloat(transaction.amount),
          phone: 'N/A', // If phone numbers are not available in the data
          paymentId: transaction.payment_id || 'N/A',
          status: transaction.status || 'N/A', // Adding status
        }));

        setPaymentHistory(formattedData);
        setFilteredHistory(formattedData); // Initially show all transactions
      } catch (error) {
        console.error('Error fetching transaction data:', error);
      }
    };
    
    fetchTransactionData();
  }, []);

  // Filter the payment history based on the selected filter
  useEffect(() => {
    if (filter === 'All') {
      setFilteredHistory(paymentHistory);
    } else {
      setFilteredHistory(paymentHistory.filter(payment => payment.status === filter));
    }
  }, [filter, paymentHistory]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const now = new Date();
    const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear().toString().slice(-2)}`;

    const newPayment = {
      userType: formData.category,
      date: formattedDate,
      amount: Number(formData.amount),
      phone: formData.phoneNumber,
      paymentId: formData.paymentId
    };

    setPaymentHistory(prev => [newPayment, ...prev]);
    setFilteredHistory(prev => [newPayment, ...prev]);

    setFormData({
      category: '',
      phoneNumber: '',
      amount: '',
      paymentId: ''
    });
  };

  return (
    <div style={styles.container}>
      {/* <h2 style={styles.header}>Add Payments from CLNS</h2> */}
      
      {/* <form onSubmit={handleSubmit} style={styles.formContainer}>
        <select 
          name="category"
          value={formData.category}
          onChange={handleInputChange}
          style={styles.select}
          required
        >
          <option value="">Select Category</option>
          <option value="Student">Student</option>
          <option value="Lawyer">Lawyer</option>
          <option value="Client">Client</option>
        </select>

        <input
          type="tel"
          name="phoneNumber"
          placeholder="Enter Phone Number"
          value={formData.phoneNumber}
          onChange={handleInputChange}
          style={styles.input}
          required
        />

        <input
          type="number"
          name="amount"
          placeholder="Enter Amount"
          value={formData.amount}
          onChange={handleInputChange}
          style={styles.input}
          required
        />

        <input
          type="text"
          name="paymentId"
          placeholder="Enter Payment id"
          value={formData.paymentId}
          onChange={handleInputChange}
          style={styles.input}
          required
        />

        <button type="submit" style={styles.saveButton}>
          Save
        </button>
      </form> */}

      <div>
        <label>Filter Transactions: </label>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} style={styles.select}>
          <option value="All">All</option>
          <option value="COMPLETED">Completed</option>
          <option value="PENDING">Pending</option>
        </select>
      </div>

      <h3 style={styles.historyHeader}>Pay History</h3>
      
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>User Type</th>
            <th style={styles.th}>Date</th>
            <th style={styles.th}>Amount</th>
            <th style={styles.th}>Phone no.</th>
            <th style={styles.th}>Payment Id</th>
            <th style={styles.th}>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredHistory.map((payment, index) => (
            <tr key={index}>
              <td style={styles.td}>{payment.userType}</td>
              <td style={styles.td}>{payment.date}</td>
              <td style={styles.td}>{payment.amount}</td>
              <td style={styles.td}>{payment.phone}</td>
              <td style={styles.td}>{payment.paymentId}</td>
              <td style={styles.td}>{payment.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionPage;
